import { render, staticRenderFns } from "./InstrumentRow.vue?vue&type=template&id=061a1790&"
import script from "./InstrumentRow.vue?vue&type=script&lang=js&"
export * from "./InstrumentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports